import { api } from "@/lib/api";
import { formatNumber } from "@/lib/format";

export const kb = (b) => (b == null ? "—" : b > 1024 * 1024 ? `${formatNumber(b / 1048576, 1)} MB` : `${formatNumber(b / 1024)} KB`);

export const TYPE_LABEL = { gunluk: "Günlük", haftalik: "Haftalık", aylik: "Aylık", manuel: "Manuel", guvenlik: "Güvenlik (restore öncesi)", drtest: "Restore testi" };

export async function downloadBackup(id, password) {
  const res = await api.post(`/backup/${id}/download`, { password }, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || "yedek.enc";
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
  return name;
}

export async function blobError(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text()).detail; } catch { return null; }
  }
  return null;
}
